import { IGetBancoPagamentoByIdUseCase } from "../../../presentation/useCases/read/get_banco_pagamento_by_id_use_case";
import { BancoPagamento } from "../../models/banco_pagamento";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetBancoPagamentoByIdUseCase
 */

export class GetBancoPagamentoByIdUseCase implements IGetBancoPagamentoByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getBancoPagamentoById(idBancoPagamento: number): Promise<BancoPagamento> {
    return await this.repository.getBancoPagamentoById(idBancoPagamento);

  }
}
